import type { FC } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useAppStore } from '@/stores/appStore';
import { useCoursesStore } from '@/stores/coursesStore';

export const CoursePage: FC = () => {
  const { courseId } = useParams<{ courseId: string }>();
  const { entitlements } = useAppStore();
  const { courses } = useCoursesStore();

  if (!courseId) {
    return <Navigate to="/courses" replace />;
  }

  if (!courses.find(course => course.id === courseId)) {
    return <Navigate to="/courses" replace />;
  }

  // Check if user has entitlement for this course
  const hasEntitlement = entitlements.includes(courseId);

  // Navigate based on entitlement
  if (hasEntitlement) {
    return <Navigate to={`/course/${courseId}/contents`} replace />;
  } else {
    return <Navigate to={`/course/${courseId}/landing`} replace />;
  }
};